module.exports = __webpack_public_path__ + "img/Edenkia_120X35.144cd5d8.png";